import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/icon-huamianmiaoshu.png';
const _hoisted_1 = {
  class: "content-review"
};
const _hoisted_2 = {
  class: "right-content-image-title"
};
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "right-content-image-content"
};
const _hoisted_5 = {
  class: "violation-item-content"
};
const _hoisted_6 = {
  class: "violation-item-original"
};
const _hoisted_7 = {
  class: "violation-item-reason"
};
const _hoisted_8 = {
  class: "violation-item-suggestion"
};
const _hoisted_9 = {
  class: "violation-item-position"
};
const _hoisted_10 = {
  key: 1,
  class: "no-violations"
};
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { fetchSmartReview } from '@/request/aiAction';
import { copyTexts } from '@/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'ContentReviewer',
  props: {
    content: {}
  },
  emits: ["replace"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const violations = ref([]);
    const isLoading = ref(false);
    const handleCopy = violation => {
      copyTexts(violation.content);
    };
    const handleReplace = (violation, index) => {
      emit('replace', violation, index);
    };
    // 智能审查
    const handleSmartReview = async () => {
      isLoading.value = true;
      try {
        const response = await fetchSmartReview({
          content: props.content
        });
        const jsonData = await response.json();
        if (!jsonData || !jsonData.data || !jsonData.data.outputs) {
          throw new Error('Invalid response structure');
        }
        const {
          outputs
        } = jsonData.data;
        const outputText = outputs.text;
        console.log(outputText, 'outputText');
        const cleanedText = outputText.replace(/```json\s*|\s*```/g, '').trim();
        try {
          // Parse the cleaned JSON data
          const jsonObject = JSON.parse(cleanedText);
          console.log(jsonObject, 'jsonObject');
          violations.value = jsonObject.violation;
          console.log(violations.value, 'violations');
        } catch (error) {
          console.error('Error parsing JSON:', error);
          console.log('Cleaned text:', cleanedText); // Log the cleaned text for debugging
          ElMessage.error('解析审查结果失败');
        }
      } catch (error) {
        console.error('Error fetching smart review:', error);
      } finally {
        isLoading.value = false;
      }
    };
    const handleContentReviewerReplaceSuccess = index => {
      violations.value.splice(index, 1);
    };
    const initSmartReview = () => {
      handleSmartReview();
    };
    onMounted(() => {
      initSmartReview();
    });
    __expose({
      handleContentReviewerReplaceSuccess
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
        class: "right-content-image-result-content-scrollbar"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "left"
        }, [_createElementVNode("img", {
          src: _imports_0,
          fit: "contain",
          class: "left-panel-tip-img"
        }), _createElementVNode("span", null, " 智能审查 ")], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: handleSmartReview,
          class: "right-content-image-title-right-button",
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass([isLoading.value ? 'ri-loader-line' : 'ri-loop-left-line', {
              rotating: isLoading.value
            }])
          }, null, 2), _createElementVNode("span", null, _toDisplayString(isLoading.value ? '审查中...' : '重新审查'), 1)]),
          _: 1
        }, 8, ["disabled"])])]), _createElementVNode("div", _hoisted_4, [(isLoading.value ? true : violations.value.length > 0) ? _withDirectives((_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          "element-loading-text": "审查中...",
          class: "violations-list"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(violations.value, (violation, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["violation-item", {
                'violation-item-success': violation.content,
                'violation-item-danger': !violation.content
              }])
            }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("strong", null, "原文：", -1)), _createTextVNode(_toDisplayString(violation.original), 1)]), _createElementVNode("p", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("strong", null, "原因：", -1)), _createTextVNode(_toDisplayString(violation.reason), 1)]), _createElementVNode("p", _hoisted_8, [_cache[3] || (_cache[3] = _createElementVNode("strong", null, "建议：", -1)), _createTextVNode(_toDisplayString(violation.suggestion), 1)])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => handleReplace(violation, index)
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" 替换 ")])),
              _: 2
            }, 1032, ["onClick"]), violation.content ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "info",
              size: "small",
              onClick: $event => handleCopy(violation)
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 复制 ")])),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)])], 2);
          }), 128))]),
          _: 1
        })), [[_directive_loading, isLoading.value]]) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_empty, {
          description: "未发现违规内容"
        })]))])]),
        _: 1
      })]);
    };
  }
});